import { render, staticRenderFns } from "./ShortDurationTradeTabs.vue?vue&type=template&id=6cb83d0c"
import script from "./ShortDurationTradeTabs.vue?vue&type=script&lang=js"
export * from "./ShortDurationTradeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports